import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import "../../styles/ourApproach/style.scss";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import $ from "jquery";
import jQuery from "jquery";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.vertical}`]: {
    marginLeft: 0, // aligns with icon
  },
  [`& .${stepConnectorClasses.line}`]: {
    minHeight: 152,
    marginLeft: 0, // push the line to align with icon center
    borderLeftWidth: 6,
    borderLeftStyle: "solid",
    borderColor: "#D1FAE5",
    borderRadius: 1,
    ...theme.applyStyles?.("dark", {
      borderColor: theme.palette.grey[800],
    }),
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    borderColor: "#34D399",
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    borderColor: "#34D399",
  },
}));

function ColorlibStepIcon(props) {
  const { active, completed, className, icon } = props;

  const icons = {
    1:
      active || completed ? (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8.5" cy="8.0791" r="8" fill="#34D399" />
        </svg>
      ) : (
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="8.5"
            cy="8"
            r="6.5"
            fill="white"
            stroke="#34D399"
            strokeWidth="3"
          />
        </svg>
      ),
    2:
      active || completed ? (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8.5" cy="8.0791" r="8" fill="#34D399" />
        </svg>
      ) : (
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="8.5"
            cy="8"
            r="6.5"
            fill="white"
            stroke="#34D399"
            strokeWidth="3"
          />
        </svg>
      ),
    3:
      active || completed ? (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8.5" cy="8.0791" r="8" fill="#34D399" />
        </svg>
      ) : (
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="8.5"
            cy="8"
            r="6.5"
            fill="white"
            stroke="#34D399"
            strokeWidth="3"
          />
        </svg>
      ),
    4:
      active || completed ? (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8.5" cy="8.0791" r="8" fill="#34D399" />
        </svg>
      ) : (
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="8.5"
            cy="8"
            r="6.5"
            fill="white"
            stroke="#34D399"
            strokeWidth="3"
          />
        </svg>
      ),
  };

  return (
    <div
      className={className}
      style={{
        zIndex: 1,
        display: "flex",
        borderRadius: "50%",
        justifyContent: "center",
        alignItems: "center",
        marginLeft: 0,
        padding: 0,
        position: "relative",
        right: "5px",
      }}
    >
      {icons[String(icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.node,
};

const steps = [
  "Select campaign settings",
  "Create an ad group",
  "Create an ad",
  "Create an ad",
];

const OurApproach = () => {
  jQuery.extend(jQuery.easing, {
    easeInOutCubic: function (x, t, b, c, d) {
      if ((t /= d / 2) < 1) return (c / 2) * t * t * t + b;
      return (c / 2) * ((t -= 2) * t * t + 2) + b;
    },
  });

  // const progressRef = useRef(null);
  const dotRefs = useRef([]);
  const [activeBorder, setActiveBorder] = useState(null);
  // const wrapperRef = useRef(null);

  const stepThresholds = [
    { min: 10, max: 36.5, cardClass: "card-1" },
    { min: 36.5, max: 63, cardClass: "card-2" },
    { min: 63, max: 90, cardClass: "card-3" },
    { min: 90, max: 101, cardClass: "card-4" },
  ];

  // useEffect(() => {
  //   const stepDots = document.querySelectorAll(".step-dot");
  //   dotRefs.current = stepDots;

  //   const handleScroll = () => {
  //     const section = document.querySelector(".our-approach-wrapper");
  //     if (!section || !progressRef.current) return;

  //     const windowHeight = window.innerHeight;
  //     const sectionTop = section.getBoundingClientRect().top;
  //     const sectionHeight = section.offsetHeight;

  //     const scrollY = window.scrollY;
  //     const offsetTop = section.offsetTop;

  //     const start = offsetTop;
  //     const end = offsetTop + sectionHeight - windowHeight;

  //     const scrolled = Math.min(Math.max(scrollY - start, 0), end - start);
  //     let progress = (scrolled / (end - start)) * 100;

  //     for (let i = 0; i < stepThresholds.length; i++) {
  //       const step = stepThresholds[i];
  //       if (progress >= step.min && progress < step.max) {
  //         if (activeBorder !== step.cardClass) {
  //           setActiveBorder(step.cardClass);
  //         }
  //         break;
  //       } else {
  //         setActiveBorder(null);
  //       }
  //     }

  //     // ✅ Invert the progress (fill from bottom to top when scrolling up)
  //     progress = 100 - progress;

  //     progressRef.current.style.height = `${progress}%`;

  //     // Update step dots
  //     dotRefs.current.forEach((dot) => {
  //       const dotPosition = parseFloat(dot.style.top); // 0%, 33.3%, etc.
  //       dot.classList.toggle("active", progress <= 100 - dotPosition);
  //     });
  //   };

  //   handleScroll();
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  // useEffect(() => {
  //   let scrolling = false;
  //   const wrapper = wrapperRef.current;

  //   const onWheel = (e) => {
  //     if (!wrapper) return;

  //     const isInsideWrapper = wrapper.contains(e.target);

  //     if (isInsideWrapper) {
  //       e.preventDefault();

  //       if (!scrolling) {
  //         scrolling = true;
  //         window.scrollBy({
  //           top: e.deltaY * 2,
  //           behavior: "smooth",
  //         });

  //         setTimeout(() => {
  //           scrolling = false;
  //         }, 50);
  //       }
  //     }
  //   };

  //   window.addEventListener("wheel", onWheel, { passive: false });

  //   return () => {
  //     window.removeEventListener("wheel", onWheel);
  //   };
  // }, []);

  return (
    <div className="ourApproach-parent-container">
      <div className="our-approach-heading-wrapper">
        <div className="our-approach-heading">Our Approach</div>
        <div className="our-approach-description">
          A systematic methodology that delivers consistent results.
        </div>
      </div>
      <div className="our-approach-wrapper">
        <div className="our-approach-sticky-container our-approach-progress">
          <div className="our-approach-heading-wrapper-height">
            <div className="our-approach-heading">Our Approach</div>
            <div className="our-approach-description">
              A systematic methodology that delivers consistent results.
            </div>
          </div>
          <div className="timeline-line">
            {/* <div className="progress-fill"></div> */}
            <div className="step-dot" style={{ top: "10%" }}></div>
            <div className="step-dot" style={{ top: "36.5%" }}></div>
            <div className="step-dot" style={{ top: "63%" }}></div>
            <div className="step-dot" style={{ top: "90%" }}></div>
          </div>
          <div className="our-approach-content">
            <div
              className={`our-approach-card left card-1 ${
                activeBorder === "card-1" ? "border-green" : ""
              }`}
            >
              <div className="our-approach-card-heading">Discovery</div>
              <div className="our-approach-card-content">
                We start by asking the right questions—because the right answers
                depend on them. This is where we listen, observe, and uncover
                the heart of the problem. We analyze your current processes,
                identify gaps, and align with your goals. No fluff. Just focused
                diagnostics that set the stage for real solutions.
              </div>
            </div>
            <div
              className={`our-approach-card right  card-2 ${
                activeBorder === "card-2" ? "border-green" : ""
              } `}
            >
              <div className="our-approach-card-heading">Strategy</div>
              <div className="our-approach-card-content">
                Based on the insights gathered, we develop a clear, executable
                strategy. This includes defining success metrics, prioritizing
                initiatives, identifying resource needs, and establishing a
                phased roadmap. Our approach is practical, flexible, and
                grounded in your business context.
              </div>
            </div>
            <div
              className={`our-approach-card left  card-3 ${
                activeBorder === "card-3" ? "border-green" : ""
              }`}
            >
              <div className="our-approach-card-heading"> Implementation</div>
              <div className="our-approach-card-content">
                With strategy in place, we move swiftly into execution. Our
                teams integrate with yours to deliver scalable, reliable
                solutions—whether it's a product rollout, process automation, or
                digital transformation initiative. Delivery is managed with
                transparency, agility, and a focus on measurable results.
              </div>
            </div>
            <div
              className={`our-approach-card right  card-4 ${
                activeBorder === "card-4" ? "border-green" : ""
              }`}
            >
              <div className="our-approach-card-heading">Optimization</div>
              <div className="our-approach-card-content">
                Post-launch, we don’t walk away. We monitor, measure, and
                refine. From technical performance to user adoption and business
                impact, we ensure your solution evolves to stay aligned with
                changing needs. Continuous improvement isn’t an
                afterthought—it’s part of the process.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurApproach;
